import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SwiftIdApplicationSubmitCollection } from './swift-id-application-submit.types';

export function swiftIdApplicationSubmitBackend(): Backend<SwiftIdApplicationSubmitCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (authUid, application) => ({
      asFormData: false,
      endpoint: 'swift-id/enqueueApplication.php',
      isGaf: true,
      method: 'POST',
      payload: {
        applicationId: application.id,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
